import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import './App.css';

import Home from './pages/Home';
import Marketplace from './pages/Marketplace';
import AssetDetail from './pages/AssetDetail';
import Login from './pages/Login';
import Signup from './pages/Signup';
import LoanApplication from './pages/LoanApplication';
import Dashboard from './pages/Dashboard';
import RealCREProperties from './pages/RealCREProperties';
import CREPropertyDetail from './pages/CREPropertyDetail';
import CRELoanApplication from './pages/CRELoanApplication';
import HowItWorks from './pages/HowItWorks';
import ExampleTransaction from './pages/ExampleTransaction';
import PropertyDealAnalysis from './pages/PropertyDealAnalysis';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/marketplace" element={<Marketplace />} />
          <Route path="/real-cre" element={<RealCREProperties />} />
          <Route path="/cre-property/:id" element={<CREPropertyDetail />} />
          <Route path="/apply-cre/:id" element={<CRELoanApplication />} />
          <Route path="/asset/:id" element={<AssetDetail />} />
          <Route path="/apply/:id" element={<LoanApplication />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/deal-analysis/:propertyId" element={<PropertyDealAnalysis />} />
          <Route path="/calculator" element={<Home />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/example-transaction" element={<ExampleTransaction />} />
          <Route path="/partnership" element={<ExampleTransaction />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
